module.exports = __webpack_public_path__ + "img/viewAttachments.09ba631a.gif";